import * as R from 'ramda';
import React from 'react';
import {ChipField} from 'react-admin';
import ColorHash from 'color-hash';


const colorHash = new ColorHash();


export const ChipFieldStationUID = (props) => {
    const uid = R.pathOr(
        R.pathOr('0000', ['record', 'station_uid'], props),
        ['record', 'uid'], props);
    const color = colorHash.hex(uid);
        return (
        <ChipField
            {...props}
            style={{
                backgroundColor: color,
                color: 'white'
            }}/>
    )
}